import { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../../css/Login.css";
// import pana from "../../../assets/pana.png";
// import BobLogo from "../../../assets/bob-logo1.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import authApi from "../services/auth.api";
import { setCredentials } from "../store/userSlice";
import { Button, Modal } from "react-bootstrap";
import { portal, config } from "../../../config/portalConfig";

const Login = () => {
  const [publicKey, setPublicKey] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
const [acceptDisclaimer, setAcceptDisclaimer] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    fetch("/public_key.pem")
      .then((res) => res.text())
      .then((key) => setPublicKey(key))
      .catch((err) => console.error("Failed to load public key:", err));
  }, []);
  const hashPassword = (password) => {
    return CryptoJS.SHA256(password).toString(); // hex string
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setFormErrors((prev) => ({ ...prev, email: "" }));
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setFormErrors((prev) => ({ ...prev, password: "" }));
  };

  const encryptWithOAEP = async (data, publicKeyPem) => {
    const encoder = new TextEncoder();
    const pem = publicKeyPem
      .replace(/-----BEGIN PUBLIC KEY-----/, "")
      .replace(/-----END PUBLIC KEY-----/, "")
      .replace(/\s/g, "");
    const binaryDer = Uint8Array.from(atob(pem), (c) => c.charCodeAt(0));
    const key = await window.crypto.subtle.importKey(
      "spki",
      binaryDer.buffer,
      {
        name: "RSA-OAEP",
        hash: "SHA-256",
      },
      false,
      ["encrypt"],
    );
    const encrypted = await window.crypto.subtle.encrypt(
      { name: "RSA-OAEP" },
      key,
      encoder.encode(data),
    );
    return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,10}$/.test(email)) {
      errors.email = "Enter valid email";
    }
    if (!password.trim()) errors.password = "Password is required";
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    if (!publicKey) {
      toast.error("Public key not loaded yet!");
      return;
    }
    setLoading(true);
    const hashedPassword = hashPassword(password);
    const encryptedCredentials = await encryptWithOAEP(
      `${email}|${hashedPassword}`,
      publicKey,
    );
    try {
      const response = await authApi.login(encryptedCredentials);
      if (response.data?.data?.passwordExpired) {
        setShowExpiredModal(true);
      }
      if (!response.data?.data?.loginSuccess) {
        const errorMessage =
          response.data?.data?.responseMessage ||
          "Login failed. Please try again.";
        toast.error(errorMessage);
        return;
      }
      dispatch(setCredentials(encryptedCredentials));
      localStorage.setItem("portal", portal);

      toast.success("An OTP has been sent to your registered mobile number.");
      navigate(`/${portal}/otp-verification`, {
        state: {
          email: email,
          loginResponse: response.data?.data, // Pass the login response data
          from: location.state?.from,
        },
        replace: true,
      });
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Login failed. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };
  const handleRedirectToChangePassword = async () => {
    setShowExpiredModal(false);
    setLoading(true);
    try {
      await authApi.forgotPassword(email);
      toast.success("OTP has been sent to your registered email.");
      navigate(`/${portal}/change-password-verification`, {
        state: { email },
      });
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Failed to send OTP. Please try again.",
      );
      setShowExpiredModal(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="login-container">
        <div className="left-panel" style={{ backgroundColor: config.primaryBackgroundColor }}>
          <img src={config.image} alt="Illustration" />
        </div>
        <div className="right-panel">
          <div className={`${portal === "sagarsoft" ? "logo1" : "logo"}`}>
            {/* <img src={BobLogo} alt="Logo" /> */}
            <img src={config.logo}  className={`img-fluid ${portal === "sagarsoft" ? "sagarsoft-logo" : ""}`} alt="Logo" />
            {/* <h5 className="mt-1">Welcome to Candidate Login</h5> */}
            <h5 className="mt-1">{config.title}</h5>
          </div>
          <form className="login_form" onSubmit={handleLogin} autoComplete="off" noValidate>
            <label>
              Email Id <span className="text-danger">*</span>
            </label>
            <input
              id="email"
              type="email"
              value={email}
              autoComplete="off"
              onChange={handleEmailChange}
              className={`form-control text-muted ${formErrors.email ? "is-invalid" : "mb-4"}`}
              placeholder="Enter email"
            />
            {formErrors.email && (
              <div className="invalid-feedback mb-4">{formErrors.email}</div>
            )}
            <label htmlFor="password">
              Password <span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={handlePasswordChange}
                autoComplete="off"
                className={`form-control text-muted ${formErrors.password ? "is-invalid" : ""}`}
                placeholder="Enter password"
                style={{ paddingRight: "40px", marginBottom: "0.25rem" }}
              />
              <FontAwesomeIcon
                icon={showPassword ? faEye : faEyeSlash}
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: formErrors.password ? "30px" : "15px",
                  top: "49%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#666",
                }}
                size="sm"
                title={showPassword ? "Hide password" : "Show password"}
              />
            </div>
            {formErrors.password && (
              <div className="invalid-feedback d-block">
                {formErrors.password}
              </div>
            )}
            <p className="forgot-link mb-4">
              <Link
                to={`/${portal}/forgot-password`}
                replace
              >
                Forgot Password?
              </Link>
            </p>
            {/* <button className="login-button" type="submit" disabled={loading}> */}
            <button
              className="login-button"
              type="submit"
              disabled={loading}
              style={{
                backgroundColor: config.primaryColor,
                borderColor: config.primaryColor,
              }}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
           <p className="register-link">
  New User?{" "}
  <button
    type="button"
    className="btn btn-link p-0"
    style={{
      textDecoration: "underline",
      color: "#0d6efd",
      fontSize: "inherit",
    }}
    onClick={() => {
      setAcceptDisclaimer(false);
      setShowDisclaimerModal(true);
    }}
  >
    Register Here
  </button>
</p>
          </form>
        </div>
      </div>
      <Modal
        show={showExpiredModal}
        onHide={() => setShowExpiredModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header className="border-bottom pb-2 pt-2" closeButton>
          <Modal.Title className="cerhead" style={{ fontSize: "16px" }}>
            Password Expired
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your password has expired. Please click on change password, enter your
          OTP and change your password to continue.
        </Modal.Body>
        <Modal.Footer style={{ border: "none" }}>
          <Button
            variant="secondary"
            style={{ fontSize: "14px" }}
            onClick={() => setShowExpiredModal(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{
              // backgroundColor: "#ff6a00",
              backgroundColor: config.primaryColor,
              color: "white",
              border: "none",
              fontSize: "14px",
            }}
            onClick={handleRedirectToChangePassword}
            disabled={loading}
          >
            {loading ? "Sending OTP..." : "Change Password"}
          </Button>
        </Modal.Footer>
      </Modal>



      
<Modal
  show={showDisclaimerModal}
  onHide={() => {
    setAcceptDisclaimer(false);
    setShowDisclaimerModal(false);
  }}
  centered
  backdrop="static"
  dialogClassName="privacy-modal"
>
  <Modal.Header
    closeButton
    style={{
      borderBottom: "none",
      padding: "20px 25px 10px",
    }}
  >
    <Modal.Title
      style={{
        width: "100%",
        textAlign: "center",
        color: "#F26A21",
        fontWeight: 600,
        fontSize: "1.25rem", // Same as custom popup
      }}
    >
      Disclaimer
    </Modal.Title>
  </Modal.Header>

  <Modal.Body
    style={{
      maxHeight: "450px",
      overflowY: "auto",
      padding: "0 30px 20px",
      color: "#555",
    }}
  >
    <p
      style={{
        marginTop: "15px",
        lineHeight: "1.6",
        fontSize: "0.95rem",
      }}
    >
      To process your recruitment application, we collect and process
      personal data such as your name, contact details, date of birth,
      photograph, educational and employment information, identity
      documents, payment details, examination/interview records, and
      other information provided by you.
    </p>

    <p
      style={{
        marginTop: "10px",
        lineHeight: "1.6",
        fontSize: "0.95rem",
      }}
    >
      Your data will be used for registration, application processing,
      fee collection and refunds, examinations and interviews,
      eligibility verification, communication, selection and appointment
      processes, grievance handling, and compliance with legal
      requirements. We may also use AI-enabled tools and automated
      processing for activities such as data validation, fraud detection,
      scheduling, and recruitment support functions, with appropriate
      human oversight over final decisions.
    </p>

    <p
      style={{
        marginTop: "10px",
        lineHeight: "1.6",
        fontSize: "0.95rem",
      }}
    >
      Your information may be shared, on a need-to-know basis, with
      payment gateway providers, examination agencies, technology and AI
      service providers, verification agencies, auditors, and statutory
      or regulatory authorities.
    </p>

    <p
      style={{
        marginTop: "10px",
        lineHeight: "1.6",
        fontSize: "0.95rem",
      }}
    >
      By proceeding with your application, you acknowledge that you have
      read and understood this Privacy Notice and consent to the
      collection, use, processing, including AI-assisted processing, and
      sharing of your personal data for the purposes stated above.
    </p>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginTop: "20px",
        gap: "10px",
      }}
    >
      <input
        type="checkbox"
        id="acceptDisclaimer"
        checked={acceptDisclaimer}
        onChange={(e) => setAcceptDisclaimer(e.target.checked)}
        style={{
          width: "18px",
          height: "18px",
          accentColor: "#F26A21",
          cursor: "pointer",
        }}
      />

      <span
        style={{
          fontSize: "0.95rem",
          color: "#555",
        }}
      >
        I have read and understood the Privacy Notice and hereby provide
        my explicit consent for the collection, processing, storage and
        sharing of my personal data with authorized third parties for
        recruitment-related purposes, in accordance with the Digital
        Personal Data Protection Act, 2023.
      </span>
    </div>
  </Modal.Body>

  <Modal.Footer
    style={{
      borderTop: "none",
      justifyContent: "center",
      paddingBottom: "25px",
    }}
  >
    <Button
      disabled={!acceptDisclaimer}
      style={{
        backgroundColor: "#F26A21",
        border: "none",
        color: "white",
        padding: "0.5rem 2rem",
        borderRadius: "8px",
        fontSize: "1rem",
        minWidth: "120px",
        opacity: acceptDisclaimer ? 1 : 0.6,
        cursor: acceptDisclaimer ? "pointer" : "not-allowed",
      }}
      onClick={() => {
        setShowDisclaimerModal(false);
        navigate(`/${portal}/register`, {
          replace: true,
          state: {
            disclaimerAccepted: true,
          },
        });
      }}
    >
      OK
    </Button>
  </Modal.Footer>
</Modal>


    </>
  );
};
export default Login;
